<template>
  <div class="product-list flex-space-between">
    <div
      v-for="product in productsPlaceholder"
      class="product-item"
    >
      <div class="placeholder">
        <div class="placeholder-content" />
      </div>
    </div>

    <div v-for="product in products" class="product-item">
      <product :product="product" />
    </div>
  </div>
</template>

<script>
import mbff from "@/libs/mbff"
const ww8 = require("@/libs/ww8");

const router = require("@/libs/router");
import ImageWithLoading from "@/components/ImageWithLoading";
import Product from "@/components/Product";
const axios = require("axios");

export default {
  props: ["config"],
  components: {
    ImageWithLoading,
    Product
  },
  data() {
    return {
      products: [],
      productsPlaceholder: [],
      productExtInfo: []
    };
  },
  mounted() {
    var self = this;
    if (!this.config.products) return
    this.products = this.config.products.map(id => {
      return {
        name: " ",
        productType: " ",
        price: { regularPrice: null }
      };
    });
    this.productsPlaceholder = this.products;
    self.fetchProducts();
  },
  methods: {
    fetchProducts() {
      const self = this;
      mbff
        .get(`/content/products?ids=${this.config.products.join(",")}`)
        .then(function(response) {
          const products = response.data;
          self.products = products;
          self.productsPlaceholder = [];
        });
    },
    viewProduct(product) {
      router.open("product", {
        id: product.id,
        type: product.itemType,
        seriesId: product.seriesId
      });
    }
  }
};
</script>

<style scoped>
.product-list {
  position: relative;
  flex-wrap: wrap;
  align-items: stretch;
  background-color: #f6f6f6;
  padding: 10px 10px 0px 10px;
}
.product-item {
  position: relative;
  width: calc(50% - 5px);
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
}
.placeholder {
  height: 300px;
  padding: 20px;
}

.placeholder-content{
  height: 50%;
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/ProductListComponent.vue